import { api } from "apiConnections";
import { AxiosRequestConfig } from "axios";
import RequestUrlId from "types/RequestUrlId";

type RequestDestroyAccess = {
    id: number;
    locationId: number;
};

const requests = {
    access: {
        destroy: (config: AxiosRequestConfig, url: RequestDestroyAccess) =>
            api.delete(
                `/order/v2/users/accesses/${url.id}/location/${url.locationId}`,
                config
            ),
        fetch: (config: AxiosRequestConfig, url: RequestUrlId) =>
            api.get(`/order/v2/users/accesses/${url.id}`, config),
        update: (data: object, config: AxiosRequestConfig, url: RequestUrlId) =>
            api.put(`/order/v2/users/accesses/${url.id}`, data, config),
    },
    locations: {
        fetch: (config: AxiosRequestConfig) =>
            api.get(`/order/v2/locations/all`, config),
        roles: (config: AxiosRequestConfig, url: RequestUrlId) =>
            api.get(`/order/v2/locations/${url.id}/roles`, config),
    },
};

export default requests;
